import React, { useState, useEffect } from 'react'
import { IToast } from 'app/shared/state/toast-context'
import Alert from '@material-ui/lab/Alert'
import { useStyles } from './toast.styles'

type Props = {
  toast: IToast
}

/**
 * @param {Props} props
 * @return {*} 
 */
const Toast = (props: Props) => {
  const classes = useStyles()
  
  const { toast } = props

  const [show, setShow] = useState(true)

  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(false)
    }, toast.autoHideDuration || 10000)
    return () => clearTimeout(timer)
  }, [toast])

  if(!show)
  {
    return <></>
  }

  return <Alert className={classes.root} onClose={() => {
    setShow(false)
  }} 
  severity={toast.variant}>
    {toast.message}
  </Alert>

}

export default Toast
